<template>
  <li class="recommendation-item">
    <logo-loading v-if="loading" color="#d7d7db" class="preview__loading" />
    <transition name="fade">
      <recommendation-preview
        ref="recommendationPreviewRef"
        :recommendation="recommendation"
        @prisma-loaded="setLoading"
      />
    </transition>
  </li>
</template>

<script>
import RecommendationPreview from '~/components/product-recommendation/RecommendationPreview.vue'
import LogoLoading from '~/components/loadings/logo'

export default {
  name: 'RecommendationItem',
  components: {
    RecommendationPreview,
    LogoLoading,
  },
  props: {
    recommendation: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      loading: true,
    }
  },
  methods: {
    setLoading(loaded) {
      this.loading = !loaded
    },
  },
}
</script>

<style lang="scss">
@import '~/assets/css/variables.scss';

.recommendation-item {
  list-style: none;
  flex-shrink: 0;
  width: 250px;
  min-height: 310px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: 1px solid lighten($light-pink-border, 3%);
  border-radius: 12px;
  background-color: transparent;
  transition: border-color 0.1s ease;
  box-sizing: border-box;

  &:hover {
    border-color: $light-pink-border;
  }
}
</style>
